<template>
<div>
  <div>
    <card>
      <div slot="title">
        <div class="flex" style="justify-content: space-between">
          <h4>当日打卡统计</h4>
<!--          <select-range  @search="search" ref="date" :disabledDate=false></select-range>-->
          <div style="display: flex;justify-content: right">
            <Date-picker style="width: 200px;margin-top: 5px;margin-right: 15px" type="date" @on-change="search" v-model="searchData.date" placeholder="选择日期" format="yyyy-MM-dd"></Date-picker>
            <Select v-model="searchData.companyType"  placeholder="公司名称" @on-change="search" class="inputwidth">
  <!--            <Option value=''>请选择</Option>-->
              <Option v-for="(item,index) in companyListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
            </Select>
          </div>
        </div>
      </div>
      <Table
        :columns="columns" :data="data" :loading="loading"
      ></Table>
    </card>
  </div>
  <div style="text-align:right;">
      <button class="goback" @click="back">返回</button>
  </div>
</div>
</template>

<script>
  import Card from './Card'
  // import SelectRange from './SelectRange'
  import {findClockinRecordStatics} from "../../api/clockin";
  import {formatDateTime} from "utils/format";

  export default {
    name: "clockinstatics",
    components:{
      Card,
      // SelectRange,
      // TableList
    },
    data(){
      return {
        current:1,
        total:0,
        loading:false,
        data:[],
        companyListData:[{
          value: 'e498159c2cee4e129d200fa7a39ba055',
          text: '北京分公司',
        },
          {
            value: '0b8d764f580642f3b4ec6fec6b8bfa66',
            text: '新疆分公司',
          }],
        columns:[
          {
            title: '项目',
            key: 'projectName',
            align: 'center',
            width:100,
            render:(h,params)=>{
              return h('a',{
                on: {
                  click: () => {
                    this.$nextTick( ()=> {
                      this.$router.push({path:'/app/clock',query:{projectFid:params.row.projectFid}});
                    })
                  }
                },
              },params.row['projectName'])
            }
          },
          {title:' '},
          {
            title: '总人数',
            key: 'totalPersonNumber',
            align: 'center',
            width:100,
          },
          {title:' '},
          {
            title: '打卡人数',
            key: 'clockinNumber',
            align: 'center',
            width:100,
          },
          {title:' '},
          {
            width:100,
            title: '上班打卡',
            key: 'workClock',
            align: 'center'
          },
          {title:' '},
          {
            width:100,
            title: '正常',
            key: 'normal',
            align: 'center'
          },
          {title:' '},
          {
            width:100,
            title: '迟到',
            key: 'late',
            align: 'center'
          },
          {title:' '},
          {
            width:100,
            title: '矿工',
            key: 'absenteeism',
            align: 'center'
          },
          {title:' '},
          {
            width:140,
            title: '早退',
            key: 'earlyOff',
            align: 'center'
          },
          {title:' '},
          {
            width:140,
            title: '下班打卡',
            key: 'offClock',
            align: 'center'
          },
        ],
        searched:null,
        searchData: {
          companyType: '',
          date:''
        },
      }
    },
    watch:{
      // projectFids:{
      //   deep:true,
      //   handler(){
      //     this.search(this.$refs['date'].searchParams)
      //   }
      // }
      // setValue(){
      //   this.searchData.companyType = this.companyListData[0].value
      // }
    },
    props:{
      // projectFid:{
      //   type:String,
      //   default:''
      // },
      // projectFids:{
      //   type:Array,
      //   default(){
      //     return []
      //   }
      // },

    },
    methods:{
      search(){
        const params={
          clockTime:this.searchData.date,
          orgUid:this.searchData.companyType
        }
        this.loading=true
        findClockinRecordStatics(params).then(res=>{

          this.data=res.data ||[]

        }).catch(()=>{return}).finally(()=>{
          this.loading=false

        })

      },
      back() {
        this.$router.push({ path: '/app/clock' });
      },
    },
    created() {
      this.searchData.companyType = this.companyListData[0].value
      console.log(this.$route.query.time)
      let d = this.$route.query.time?new Date(this.$route.query.time):new Date()
      this.searchData.date = d
      this.search()
    }
  }
</script>

<style scoped>
.inputwidth {
  width: 200px;
  padding-top:5px;
}
.goback {
  font-size:15px;
  color: red;
  margin-right: 20px;
}
</style>
